(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var productCarousels = document.querySelectorAll('[data-section-type="product-carousel"] .splide');

    if (productCarousels.length > 0) {
      // Load Splide CSS if not already loaded
      if (!document.querySelector('link[href*="splide.min.css"]')) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/css/splide.min.css';
        document.head.appendChild(link);
      }

      // Load Splide JS if not already loaded
      if (typeof Splide === 'undefined') {
        var script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js';
        script.onload = function() {
          initializeProductCarousels();
        };
        document.body.appendChild(script);
      } else {
        initializeProductCarousels();
      }
    }

    function initializeProductCarousels() {
      productCarousels.forEach(function(carousel) {
        new Splide(carousel, {
          type: 'loop',
          perPage: 4,
          perMove: 1,
          gap: '1.5rem',
          pagination: false,
          breakpoints: {
            990: {
              perPage: 3
            },
            750: {
              perPage: 2
            },
            480: {
              perPage: 1
            }
          }
        }).mount();
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
